import { Radio, Tag, Typography } from "@flash-tecnologia/hros-web-ui-v2";
import {
  ClickableShapeIcon,
  OptionContainer,
  RadioCard,
  RadioCardLeft,
  RadioCardRight,
  RadioOptionText,
} from "./styled";

interface CreateOptionsProps {
  canMigrate?: boolean;
  willMigrate?: boolean;
  setWillMigrate: (value: boolean) => void;
  setIsFormDisabled: (value: boolean) => void;
}

export const CreateOptions = ({
  canMigrate,
  willMigrate,
  setWillMigrate,
  setIsFormDisabled,
}: CreateOptionsProps) => {
  return (
    <OptionContainer>
      <RadioCard
        clickable={canMigrate}
        checked={willMigrate}
        onClick={() => {
          if (canMigrate) {
            setWillMigrate(true);
            setIsFormDisabled(true);
          }
        }}
      >
        <RadioCardLeft>
          <ClickableShapeIcon
            name="IconSwitch3"
            variant="default"
            color="var(--color-secondary-50)"
            size={32}
          />
          <RadioOptionText>
            <Typography color="neutral.30" variant="body4" weight={700}>
              Transferir a pessoa para a nova empresa
            </Typography>
            <Typography color="neutral.40" variant="caption">
              Esta pessoa deixará as empresas atuais e ficará apenas na nova
              empresa.
            </Typography>
          </RadioOptionText>
        </RadioCardLeft>
        <RadioCardRight>
          <Radio
            size="small"
            name="willMigrate"
            disabled={!canMigrate}
            checked={willMigrate}
            value={willMigrate}
            error={false}
          />
        </RadioCardRight>
      </RadioCard>
      <RadioCard
        clickable
        checked={!willMigrate}
        onClick={() => {
          setWillMigrate(false);
          setIsFormDisabled(false);
        }}
      >
        <RadioCardLeft>
          <ClickableShapeIcon
            name="IconUsers"
            variant="default"
            color="var(--color-secondary-50)"
            size={32}
          />
          <RadioOptionText>
            <Tag
              size="extra-small"
              variant="yellow"
              style={{ marginBottom: 8 }}
            >
              Não recomendado
            </Tag>
            <Typography color="neutral.30" variant="body4" weight={700}>
              Duplicar o cadastro da pessoa
            </Typography>
            <Typography color="neutral.40" variant="caption">
              Vincular a pessoa em mais de uma empresa pode gerar duplicidade de
              cadastro e emissão extra de cartão.
            </Typography>
          </RadioOptionText>
        </RadioCardLeft>
        <RadioCardRight>
          <Radio
            size="small"
            name="willMigrate"
            checked={!willMigrate}
            value={!willMigrate}
            error={false}
          />
        </RadioCardRight>
      </RadioCard>
    </OptionContainer>
  );
};
